// Melanate Theme — theme.js

document.addEventListener('DOMContentLoaded', function () {

  // ── SCROLL REVEAL ──
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });


  // ── MEGA MENU ──
  var hamburger = document.querySelector('.nav-hamburger');
  var megaMenu  = document.getElementById('mega-menu');
  var closeBtn  = document.querySelector('.mega-menu-close');
  var overlay   = document.querySelector('.mega-overlay');

  function openMenu() {
    megaMenu.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    megaMenu.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (closeBtn)  closeBtn.addEventListener('click', closeMenu);
  if (overlay)   overlay.addEventListener('click', closeMenu);

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  // ── SUB-MENU ACCORDION ──
  document.querySelectorAll('.mega-nav-item.has-children .mega-nav-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var item = link.closest('.mega-nav-item');
      var isOpen = item.classList.contains('open');
      // Close all siblings
      document.querySelectorAll('.mega-nav-item.open').forEach(function (el) {
        el.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });


  // ── CART TOAST NOTIFICATION (global) ──
  function showCartToast(product) {
    var existing = document.getElementById('cart-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'cart-toast';
    toast.innerHTML =
      '<div class="cart-toast-inner">' +
        '<div class="cart-toast-icon">✓</div>' +
        '<div class="cart-toast-text">' +
          '<p class="cart-toast-title">' + (product.title || 'Item') + '</p>' +
          '<p class="cart-toast-sub">Added to your cart</p>' +
        '</div>' +
        '<a href="/cart" class="cart-toast-btn">View Cart</a>' +
        '<button class="cart-toast-close" aria-label="Close">&times;</button>' +
      '</div>';
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { toast.classList.add('visible'); });
    });
    toast.querySelector('.cart-toast-close').addEventListener('click', function() {
      toast.classList.remove('visible');
      setTimeout(function() { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 350);
    });
    setTimeout(function() {
      toast.classList.remove('visible');
      setTimeout(function() { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 350);
    }, 4000);
  }

  // ── AJAX ADD TO CART (global — product grids, related, featured) ──
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var originalText = btn.innerHTML;
      btn.innerHTML = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        btn.innerHTML = '✓ Added';
        showCartToast(item);
        updateCartCount();
        setTimeout(function () {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.innerHTML = originalText;
        btn.disabled = false;
      });
    });
  });

  // ── BUY NOW (global — add to cart then go to /cart) ──
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        btn.textContent = 'Try Again';
        btn.disabled = false;
      });
    });
  });

  // ── SHARED: update cart count badge ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

});


// ── FAQ TABS ──
document.querySelectorAll('.faq-tab').forEach(function (tab) {
  tab.addEventListener('click', function () {
    var target = tab.getAttribute('data-tab');
    // Tabs
    document.querySelectorAll('.faq-tab').forEach(function (t) { t.classList.remove('active'); });
    tab.classList.add('active');
    // Panels
    document.querySelectorAll('.faq-panel').forEach(function (p) { p.classList.remove('active'); });
    var panel = document.querySelector('.faq-panel[data-panel="' + target + '"]');
    if (panel) panel.classList.add('active');
  });
});

// ── FAQ ACCORDION ──
document.querySelectorAll('.faq-question').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var item = btn.closest('.faq-item');
    var isOpen = item.classList.contains('open');
    // Close all in this panel
    var panel = btn.closest('.faq-panel');
    if (panel) {
      panel.querySelectorAll('.faq-item.open').forEach(function (el) { el.classList.remove('open'); });
    }
    if (!isOpen) item.classList.add('open');
    btn.setAttribute('aria-expanded', !isOpen);
  });
});
